export default {
  computed: {
    adminAccount () {
      return this.$store.state.header?.headerData?.isAdmin ?? false
    }
  }
}
